import { FiberStatusTypeId as FiberStatusTypeId$1, done as done$1, running as running$1, suspended as suspended$1, isFiberStatus as isFiberStatus$1, isDone as isDone$1, isRunning as isRunning$1, isSuspended as isSuspended$1 } from '../../internal/fiberStatus.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const FiberStatusTypeId = FiberStatusTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const done = done$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const running = running$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const suspended = suspended$1;

/**
 * Returns `true` if the specified value is a `FiberStatus`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isFiberStatus = isFiberStatus$1;

/**
 * Returns `true` if the specified `FiberStatus` is `Done`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isDone = isDone$1;

/**
 * Returns `true` if the specified `FiberStatus` is `Running`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRunning = isRunning$1;

/**
 * Returns `true` if the specified `FiberStatus` is `Suspended`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isSuspended = isSuspended$1;

export { FiberStatusTypeId, done, isDone, isFiberStatus, isRunning, isSuspended, running, suspended };
